/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.academy.simulation.environment.rpc.PortalService
 */

export const createPortalRpc = {
  serviceName: 'com.hubspot.academy.simulation.environment.rpc.PortalService',
  rpcName: 'createPortal',
  auth: 'app',
  fingerprint: '4qS4OkgLmKX632hfrsF295auZkbS6k3j',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getPortalProvisioningStatusRpc = {
  serviceName: 'com.hubspot.academy.simulation.environment.rpc.PortalService',
  rpcName: 'getPortalProvisioningStatus',
  auth: 'app',
  fingerprint: 'PYRWO60DTHvwG7D3yuMCmpauZkbS6k3j',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};